export const DASHBOARD_INITIAL_MORTGAGE_INPUT_MODAL = 'dashboard-initial-mortgage-input-modal';
